import { Grid, Paper, Typography } from "@mui/material"
import { Title } from "components/Common/Title"
import { ReportListButton } from "components/Report/ReportListButton"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import deviceService from "services/deviceService"
import licenseService from "services/licenseService"
import organizationService from "services/organizationService"
import userService from "services/userService"
import { setDevices } from "slices/deviceSlice"
import { setLicenses } from "slices/licenseSlice"
import { setCurrentOrganization } from "slices/organizationSlice"
import { setUsers } from "slices/usersSlice"

export function Organization() {
  const { id } = useParams()
  const dispatch = useAppDispatch()

  const currentOrganization = useAppSelector((state) => state.organization.currentOrganization)
  const users = useAppSelector((state) => state.users.users)
  const devices = useAppSelector((state) => state.device.devices)
  const licenses = useAppSelector((state) => state.license.licenses)

  useEffect(() => {
    if (currentOrganization === undefined && id) {
      organizationService
        .getOrganization(id)
        .then((organization) => {
          dispatch(setCurrentOrganization(organization))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (users.length < 1 && id) {
      userService
        .getOrganizationUsers(id)
        .then((users) => {
          dispatch(setUsers(users))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (licenses.length < 1 && id) {
      licenseService
        .getOrganizationLicenses(id)
        .then((license) => {
          dispatch(setLicenses(license))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (devices.length < 1 && id) {
      deviceService
        .getOrganizationDevices(id)
        .then((devices) => {
          dispatch(setDevices(devices))
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [currentOrganization, devices.length, dispatch, id, licenses.length, users.length])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs>
              <Title>{currentOrganization?.name.toLocaleUpperCase()}</Title>
            </Grid>
            <Grid item>
              <ReportListButton />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item container spacing={3}>
        <Grid item xs={4}>
          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <Grid>
              <Grid item>
                <Title>USERS</Title>
              </Grid>
              <Grid container justifyContent="center">
                <Typography data-testid="userAmount" variant="h1">
                  {users.length}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <Grid>
              <Grid item>
                <Title>LICENSES</Title>
              </Grid>
              <Grid container justifyContent="center">
                <Typography data-testid="licenseAmount" variant="h1">
                  {licenses.length}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
            <Grid>
              <Grid item>
                <Title>DEVICES</Title>
              </Grid>
              <Grid container justifyContent="center">
                <Typography data-testid="deviceAmount" variant="h1">
                  {devices.length}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}
